<template>
    <v-navigation-drawer
            app
            persistent
            v-model="drawerToggle"
            mobile-break-point="991"
            width="106"
            color="primary"
            class="primary"
            :floating="true"
            v-if="$store.state.user.roleId !== 2"
    >
        <img class="botter-logo" src="../../assets/logo.png" alt="">
        <v-list dense class="pt-0">
            <v-list-tile
                    v-for="item in items"
                    :key="item.title"
                    :to="item.link"
                    class="d-block"
                    v-if="!(item.permission === 1 &&  $store.state.user.roleId === 3)"
            >

              <div v-if="item.show">
                <div class="svg-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 18">
                    <path fill="#FFF" fill-rule="nonzero" :d="item.icon"/>
                  </svg>
                </div>

                <div>{{ item.title }}</div>
              </div>



            </v-list-tile>
        </v-list>
    </v-navigation-drawer>
</template>

<script>
    export default {
        props: {
          drawer: {
            type: Boolean,
            default: () => {
              return true
            }
          }
        },
        data () {
            return {
                items: [
                    ],
                drawerToggle: true
            }
        },
      mounted() {
          this.items =  [
          { title: 'Build', permission: 1, show:true, link:'/build', icon:'M19 6a1 1 0 0 0 0-2h-1V2h1a1 1 0 0 0 0-2H1a1 1 0 1 0 0 2h3v2H1a1 1 0 1 0 0 2h1v2H1a1 1 0 1 0 0 2h3v2H1a1 1 0 0 0 0 2h1v2H1a1 1 0 0 0 0 2h18a1 1 0 0 0 0-2h-3v-2h3a1 1 0 0 0 0-2h-1v-2h1a1 1 0 0 0 0-2h-3V6h3zM6 2h4v2H6V2zm8 4v2h-4V6h4zM4 6h4v2H4V6zm6 4v2H6v-2h4zm-2 6H4v-2h4v2zm6 0h-4v-2h4v2zm2-4h-4v-2h4v2zm-4-8V2h4v2h-4z' },
          { title: 'Word Spotting', permission: 1, show:true, link:'/ai', icon:'M1 2h18a1 1 0 0 0 0-2H1a1 1 0 1 0 0 2zm6 8H1a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2zm9.5-5H1a1 1 0 1 0 0 2h15.5a1.5 1.5 0 0 1 0 3h-3.09l.3-.29a1.004 1.004 0 1 0-1.42-1.42l-2 2a1 1 0 0 0-.21.33 1 1 0 0 0 0 .76 1 1 0 0 0 .21.33l2 2a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42l-.3-.29h3.09a3.5 3.5 0 0 0 0-7z' },
          { title: 'NLP', link:'/nlp', permission: 1, show:true, icon:'M18.35 7.313V4.396c.646-.233 1.15-.851 1.15-1.583 0-.931-.786-1.688-1.707-1.688-.92 0-1.67.757-1.67 1.688 0 .732.467 1.35 1.113 1.583V6.75h-1.789a6.19 6.19 0 0 0-2.664-2.692V2.813a.56.56 0 0 0-.556-.563.56.56 0 0 0-.557.563v.802a6.02 6.02 0 0 0-1.113-.212V.564A.56.56 0 0 0 10 0a.56.56 0 0 0-.557.563v2.84a6.02 6.02 0 0 0-1.113.212v-.803a.56.56 0 0 0-.557-.562.56.56 0 0 0-.556.563v1.245A6.19 6.19 0 0 0 4.553 6.75h-1.79V4.396a1.684 1.684 0 0 0 1.114-1.583c0-.931-.75-1.688-1.67-1.688-.92 0-1.707.757-1.707 1.688 0 .732.504 1.35 1.15 1.583v2.917c0 .31.25.562.557.562h1.907A6.207 6.207 0 0 0 3.905 9H1.057a.56.56 0 0 0-.557.563c0 .31.249.562.557.562H3.92c.036.384.099.76.203 1.125H2.207a.56.56 0 0 0-.557.563v2.916c-.646.233-1.15.851-1.15 1.584 0 .93.786 1.687 1.707 1.687.92 0 1.67-.757 1.67-1.688 0-.732-.467-1.35-1.113-1.583v-2.354h1.67c.041 0 .078-.015.117-.024a6.163 6.163 0 0 0 3.259 2.966l1.738 2.448a.555.555 0 0 0 .904 0l1.738-2.448a6.162 6.162 0 0 0 3.245-2.942h1.801v2.354a1.684 1.684 0 0 0-1.113 1.584c0 .93.75 1.687 1.67 1.687.92 0 1.707-.757 1.707-1.688 0-.732-.504-1.35-1.15-1.583v-2.916a.56.56 0 0 0-.557-.563h-1.916a6.15 6.15 0 0 0 .203-1.125h2.863a.56.56 0 0 0 .557-.563.56.56 0 0 0-.557-.562h-2.848a6.197 6.197 0 0 0-.21-1.125h1.908a.56.56 0 0 0 .557-.563zM7.773 10.124a.56.56 0 0 1-.556-.563c0-.31.249-.562.556-.562a.56.56 0 0 1 .557.563.56.56 0 0 1-.557.562zm2.227 0a.56.56 0 0 1-.557-.563c0-.31.25-.562.557-.562a.56.56 0 0 1 .557.563.56.56 0 0 1-.557.562zm2.227 0a.56.56 0 0 1-.557-.563c0-.31.25-.562.557-.562a.56.56 0 0 1 .556.563.56.56 0 0 1-.556.562z'},
          { title: 'Insights', permission: 2, show:true, link:'/insights', icon:'M19.71.29a1 1 0 0 0-1.42 0L12 6.59l-4.29-4.3a1 1 0 0 0-1.42 0l-6 6a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0L7 4.41l4.29 4.3a1 1 0 0 0 1.42 0l7-7a1 1 0 0 0 0-1.42z'},
          { title: 'Settings', permission: 1, show:true, link: '/settings', icon:'M19.32 7.55l-1.89-.63.89-1.78A1 1 0 0 0 18.13 4L16 1.87a1 1 0 0 0-1.15-.19l-1.78.89-.63-1.89A1 1 0 0 0 11.5 0h-3a1 1 0 0 0-.95.68l-.63 1.89-1.78-.89A1 1 0 0 0 4 1.87L1.87 4a1 1 0 0 0-.19 1.15l.89 1.78-1.89.63A1 1 0 0 0 0 8.5v3a1 1 0 0 0 .68.95l1.89.63-.89 1.78A1 1 0 0 0 1.87 16L4 18.13a1 1 0 0 0 1.15.19l1.78-.89.63 1.89a1 1 0 0 0 .95.68h3a1 1 0 0 0 .95-.68l.63-1.89 1.78.89a1 1 0 0 0 1.13-.19L18.13 16a1 1 0 0 0 .19-1.15l-.89-1.78 1.89-.63a1 1 0 0 0 .68-.94v-3a1 1 0 0 0-.68-.95zM18 10.78l-1.2.4A2 2 0 0 0 15.64 14l.57 1.14-1.1 1.1-1.11-.6a2 2 0 0 0-2.79 1.16l-.4 1.2H9.22l-.4-1.2A2 2 0 0 0 6 15.64l-1.14.57-1.1-1.1.6-1.11a2 2 0 0 0-1.16-2.82l-1.2-.4V9.22l1.2-.4A2 2 0 0 0 4.36 6l-.57-1.11 1.1-1.1L6 4.36A2 2 0 0 0 8.82 3.2l.4-1.2h1.56l.4 1.2A2 2 0 0 0 14 4.36l1.14-.57 1.1 1.1-.6 1.11a2 2 0 0 0 1.16 2.79l1.2.4v1.59zM10 6a4 4 0 1 0 0 8 4 4 0 0 0 0-8zm0 6a2 2 0 1 1 0-4 2 2 0 0 1 0 4z'},
          { title: 'filters', permission: 3, show: this.botId === '1ilb9u1o1c83wyplf5', link: '/filters', icon:'M22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3z'},
        ]
      },
      watch: {
          drawer() {
            this.drawerToggle = !this.drawerToggle
          }
      },
      computed: {
        botId() {
          return this.$store.state.bot.botId
        }
      }
    }
</script>

<style lang="scss">
</style>
